module.exports = __webpack_public_path__ + "img/activity1.4ac3b221.svg";